import React from 'react'

const ToolbarContext = React.createContext({})

export { ToolbarContext }
